/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  Constants for contentModuleAmenities module
 */

export const DONE_FETCHING_CONTENT_MODULE_AMENITIES =
  '@@nzr/cityLifestyles/DONE_FETCHING_CONTENT_MODULE_AMENITIES'
export const ERROR_FETCHING_CONTENT_MODULE_AMENITIES =
  '@@nzr/cityLifestyles/ERROR_FETCHING_CONTENT_MODULE_AMENITIES'
export const RECEIVE_CONTENT_MODULE_AMENITIES =
  '@@nzr/cityLifestyles/RECEIVE_CONTENT_MODULE_AMENITIES'
export const START_FETCHING_CONTENT_MODULE_AMENITIES =
  '@@nzr/cityLifestyles/START_FETCHING_CONTENT_MODULE_AMENITIES'
